import { render, staticRenderFns } from "./BotonHome.vue?vue&type=template&id=c25a4578&scoped=true"
import script from "./BotonHome.vue?vue&type=script&lang=ts"
export * from "./BotonHome.vue?vue&type=script&lang=ts"
import style0 from "./BotonHome.vue?vue&type=style&index=0&id=c25a4578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25a4578",
  null
  
)

export default component.exports